import React from "react";

const ContactOfficer = () => {
  return <div>ContactOfficer</div>;
};

export default ContactOfficer;
